import angular from 'angular'
import './audiences.service'

angular
  .module('admin.audiences', ['admin.audiences.service'])
  .controller('AudiencesCtrl', AudiencesCtrl)

/** @ngInject */
function AudiencesCtrl(ChannelGroupChildrenService, AudiencesService, CsvService) {
  var vm = this
  vm.items = []
  vm.channelId = null
  vm.totalAmountSpent = null
  vm.numCompletedSetsInChannel = null

  ChannelGroupChildrenService.listChannel().then(function(result) {
    vm.channels = result.results
  })

  function load() {
    AudiencesService.list(vm.channelId, vm.totalAmountSpent, vm.numCompletedSetsInChannel).then(
      function(result) {
        vm.items = result.results
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  load()

  vm.load = function() {
    if (!vm.channelId || !vm.totalAmountSpent || !vm.numCompletedSetsInChannel) {
      swal('Must fill all fields', '', 'warning')
      return
    }
    load()
  }

  vm.export = function() {
    if (vm.items.length === 0) {
      swal('Must filter first', '', 'warning')
      return
    }

    CsvService.validSafari()

    var csv = CsvService.convertArrayOfObjectsToCSV({
      data: vm.items,
    })

    if (csv === null) {
      return
    }

    if (CsvService.isSafari() || CsvService.isFirefox()) {
      var link = document.createElement('a')
      link.id = 'csvDwnLink'

      document.body.appendChild(link)
      window.URL = window.URL || window.webkitURL
      var csv2 = '\ufeff' + csv,
        csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
        filename = 'audiences.csv'
      $('#csvDwnLink').attr({ download: filename, href: csvData })
      $('#csvDwnLink')[0].click()
      document.body.removeChild(link)
    } else {
      var filename = 'audiences.csv'

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv
      }

      var data = encodeURI(csv)
      var link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', filename)
      link.click()
    }
  }
}
